export default __webpack_public_path__ + "static/media/first-overlap.7fef47f8.png";